import { gridSizeMdLg6 } from "@/shared"
import { Edit } from "@mui/icons-material"
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { Box, Grid, IconButton, Tooltip, Typography } from "@mui/material"
import type React from "react"
import { useState, useCallback } from "react"
import TaskAltIcon from '@mui/icons-material/TaskAlt';
interface CustomColorPickerProps {
  initialColor?: string
  onChange?: (color: string) => void
  onClick: (color: string) => void
}

export const CustomColorPicker: React.FC<CustomColorPickerProps> = ({
  initialColor = "#000000",
  onChange,
  onClick
}) => {
  const [color, setColor] = useState(initialColor)
  const [edit, setEdit] = useState<boolean>(false)

  const handleColorChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const newColor = event.target.value
      setColor(newColor)
      if (onChange) {
        onChange(newColor)
      }
    },
    [onChange],
  )

  

  return (
    <>
      {!edit && (
        <Grid item {...gridSizeMdLg6}>
          <Typography variant="subtitle2">{`Color asignada`}</Typography>

          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            justifyItems: 'center',
            alignContent: 'center',
            alignItems: 'center'
          }}>
            <Box
              sx={{
                width: "90%",
                height: "10px",
                margin: "5px 0px",
                backgroundColor: `${initialColor}`
              }}
            ></Box>

            <IconButton onClick={() => setEdit(true)}>
              <Edit />
            </IconButton>
          </div>
        </Grid>
      )

      }

      {edit && (
        <Grid item {...gridSizeMdLg6}>
          <Typography variant="subtitle2">{`Seleccionar color`}</Typography>


          <input
            style={{
              width: '75%'
            }}
            type="color"
            value={color}
            onChange={handleColorChange}
            className="w-12 h-12 border-0 rounded cursor-pointer"
            aria-label="Seleccionar color"
          />




          <Tooltip placement="top" title='Guardar'>
            <IconButton onClick={() => {
              onClick && onClick(color)
            }}>
              <TaskAltIcon color="success" />
            </IconButton>
          </Tooltip>

          <Tooltip placement="top" title='Cancelar'>
            <IconButton
              onClick={() => setEdit(false)}
            >
              <HighlightOffIcon color="error" />
            </IconButton>
          </Tooltip>

          {/* <Button

            onClick={() => {
              onClick && onClick(color)
            }}
            color="success"
            variant="outlined"
          >Guardar</Button> */}
        </Grid>
      )

      }
    </>
  )
}

